import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { UserContext } from "../Context/UserContext";
import { jwtDecode } from "jwt-decode";
import { TransactionContext } from "../Context/TransactionContext";
import "../styleSheets/oweget.css";

function OweGet() {
  const token = localStorage.getItem("token");
  let myId = "";
  if (token) {
    const decoded = jwtDecode(token);
    myId = decoded.user.id;
  }

  const [filters, setfilters] = useState({
    type: "",
    name: "",
    status: "",
    fromDate: "",
    toDate: "",
    search: "",
  });
  const [updGetDetails, setupdGetDetails] = useState([]);
  const [updOweDetails, setupdOweDetails] = useState([]);

  const [actionLoading, setActionLoading] = useState(null);

  const [getsTotal, setGetsTotal] = useState([]);
  const [owesTotal, setOwesTotal] = useState([]);

  const { userDetails, getUserProfile } = useContext(UserContext);
  const { confirmPayment, approvePayment, rejectPayment } =
    useContext(TransactionContext);
  const [cNameIn, setcNameIn] = useState("d-flex");
  const [cNameOut, setcNameOut] = useState("d-none");
  const [btn1, setbtn1] = useState("bigBtnActive");
  const [btn2, setbtn2] = useState("bigBtnInActive");
  const [searchText, setsearchText] = useState("");

  useEffect(() => {
    const updated =
      userDetails.gets?.filter((u) => {
        const typeOk = filters.type
          ? u.transaction?.fType === filters.type
          : true;
        const nameOk = filters.name ? u.from?.name === filters.name : true;
        const statusOk = filters.status ? u.tStatus === filters.status : true;

        const txDate = new Date(u.transaction?.tDate);

        const fromOk = filters.fromDate
          ? txDate >= new Date(filters.fromDate)
          : true;

        const toOk = filters.toDate
          ? txDate <= new Date(filters.toDate + "T23:59:59")
          : true;

        const searchOk = filters.search
          ? u.from?.name
              ?.toLowerCase()
              .includes(filters.search.toLowerCase()) ||
            u.transaction?.tName
              ?.toLowerCase()
              .includes(filters.search.toLowerCase())
          : true;

        return typeOk && nameOk && statusOk && fromOk && toOk && searchOk;
      }) || [];

    updated.sort((a, b) => {
      const dateTimeA = new Date(
        `${a.transaction?.tDate} ${new Date(a.transaction?.createdAt).toTimeString()}`,
      );

      const dateTimeB = new Date(
        `${b.transaction?.tDate} ${new Date(b.transaction?.createdAt).toTimeString()}`,
      );

      return dateTimeB - dateTimeA;
    });

    setupdGetDetails(updated);
  }, [filters, userDetails.gets]);

  useEffect(() => {
    const updated =
      userDetails.owes?.filter((u) => {
        const typeOk = filters.type
          ? u.transaction?.fType === filters.type
          : true;
        const nameOk = filters.name ? u.to?.name === filters.name : true;
        const statusOk = filters.status ? u.tStatus === filters.status : true;

        const txDate = new Date(u.transaction?.tDate);

        const fromOk = filters.fromDate
          ? txDate >= new Date(filters.fromDate)
          : true;

        const toOk = filters.toDate
          ? txDate <= new Date(filters.toDate + "T23:59:59")
          : true;

        const searchOk = filters.search
          ? u.to?.name?.toLowerCase().includes(filters.search.toLowerCase()) ||
            u.transaction?.tName
              ?.toLowerCase()
              .includes(filters.search.toLowerCase())
          : true;

        return typeOk && nameOk && statusOk && fromOk && toOk && searchOk;
      }) || [];

    updated.sort((a, b) => {
      const dateTimeA = new Date(
        `${a.transaction?.tDate} ${new Date(a.transaction?.createdAt).toTimeString()}`,
      );

      const dateTimeB = new Date(
        `${b.transaction?.tDate} ${new Date(b.transaction?.createdAt).toTimeString()}`,
      );

      return dateTimeB - dateTimeA;
    });

    setupdOweDetails(updated);
  }, [filters, userDetails.owes]);

  useEffect(() => {
    setGetsTotal([]);
    updGetDetails.forEach((each) => {
      if (each.tStatus === "pending") {
        setGetsTotal((prev) => [...prev, each.amount]);
      }
    });
  }, [updGetDetails, filters, userDetails.gets]);
  let totalGetsSum = getsTotal.reduce((a, b) => a + b, 0);

  useEffect(() => {
    setOwesTotal([]);
    //updOweDetails.map((each) => setOwesTotal((prev) => [...prev, each.amount]));
    updOweDetails.forEach((each) => {
      if (each.tStatus === "pending") {
        setOwesTotal((prev) => [...prev, each.amount]);
      }
    });
  }, [updOweDetails, filters, userDetails.owes]);
  let totalOwesSum = owesTotal.reduce((a, b) => a + b, 0);

  const clickedMoneyIn = () => {
    setcNameIn("d-flex");
    setcNameOut("d-none");
    setbtn1("bigBtnActive");
    setbtn2("bigBtnInActive");
  };

  const clickedMoneyOut = () => {
    setcNameIn("d-none");
    setcNameOut("d-flex");
    setbtn1("bigBtnInActive");
    setbtn2("bigBtnActive");
  };

  const onChange = (e) => {
    setfilters({ ...filters, [e.target.name]: e.target.value });
  };

  let owegetsListNames = [];
  userDetails.gets.map((n) => {
    if (!owegetsListNames.includes(n.from.name)) {
      owegetsListNames.push(n.from.name);
    }
  });

  userDetails.owes.map((n) => {
    if (!owegetsListNames.includes(n.to.name)) {
      owegetsListNames.push(n.to.name);
    }
  });

  const onConfirm = async (senderId, receiverId, transId) => {
    if (actionLoading) return;

    try {
      setActionLoading({ id: transId, type: "confirm" }); // 🔵 ADDED

      await confirmPayment(senderId, receiverId, transId);
      await getUserProfile();
    } finally {
      setActionLoading(null); // 🔵 ADDED
    }
  };

  const onApprove = async (senderId, receiverId, transId) => {
    if (actionLoading) return;

    try {
      setActionLoading({ id: transId, type: "approve" }); // 🔵 ADDED

      await approvePayment(senderId, receiverId, transId);
      await getUserProfile();
    } finally {
      setActionLoading(null); // 🔵 ADDED
    }
  };

  const onReject = async (senderId, receiverId, transId) => {
    if (actionLoading) return;

    try {
      setActionLoading({ id: transId, type: "reject" }); // 🔵 ADDED
      await rejectPayment(senderId, receiverId, transId);
      await getUserProfile();
    } finally {
      setActionLoading(null); // 🔵 ADDED
    }
  };

  const capitalize = (word) => {
    if (!word) return "";

    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  };

  function formatToIST(isoString) {
    const date = new Date(isoString);

    const options = {
      timeZone: "Asia/Kolkata",
      hour: "2-digit",
      minute: "2-digit",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour12: false,
    };

    const parts = new Intl.DateTimeFormat("en-GB", options).formatToParts(date);

    const map = {};
    parts.forEach((p) => (map[p.type] = p.value));

    return `${map.day}-${map.month}-${map.year}  ${map.hour}:${map.minute}`;
  }

  const onReset = () => {
    setfilters({
      type: "",
      name: "",
      status: "",
      fromDate: "",
      toDate: "",
      search: "",
    });
  };

  return (
    <div>
      {/* TOP BUTTONS */}
      {userDetails.name === "Santosh" && (
        <p className="text-center">
          Net Amount : {totalGetsSum - totalOwesSum}
        </p>
      )}
      <div className="d-flex justify-content-center btn-cont mt-3">
        <button className={`${btn1} big-btn`} onClick={clickedMoneyIn}>
          To Receive
        </button>
        <button className={`${btn2} big-btn`} onClick={clickedMoneyOut}>
          To Pay
        </button>
      </div>

      {/* FILTER + SEARCH */}
      <div className="d-flex justify-content-center mt-3">
        <div className="d-flex justify-content-center filters-cont">
          <button
            className="filter-btn"
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#exampleModal"
          >
            <i className="bi bi-funnel mx-1 fs-6"></i> Filters
          </button>

          <div className="search-cont">
            <input
              className="form-control search-element me-2"
              type="search"
              placeholder="Search By Name"
              value={filters.search}
              onChange={(e) =>
                setfilters({ ...filters, search: e.target.value })
              }
            />
          </div>

          <div className="total-cont">
            {getsTotal.length > 0 ? (
              <div className={cNameIn}>
                <p>Total : {totalGetsSum}</p>
              </div>
            ) : (
              <div className={cNameIn}>
                <p>Total : 0</p>
              </div>
            )}

            {owesTotal.length > 0 ? (
              <div className={cNameOut}>
                <p>Total : {totalOwesSum}</p>
              </div>
            ) : (
              <div className={cNameOut}>
                <p>Total : 0</p>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* RECEIVE MONEY LIST */}
      <div className={`${cNameIn} flex-column`}>
        <div className="transaction-list">
          {updGetDetails.length > 0 ? (
            updGetDetails
              .filter((each) => each?.transaction)
              .map((each) => {
                const tx = each.transaction;

                return (
                  <div key={each._id} className="transaction-card">
                    <div className="t-details-cont">
                      {/* LEFT */}
                      <div className="t-left-details">
                        <img
                          className="t-img"
                          src="https://cdn-icons-png.flaticon.com/512/5932/5932535.png"
                          alt="transaction"
                        />

                        <div className="t-info">
                          <p className="t-title">
                            {capitalize(tx.tName || "Unnamed")}
                            <br />
                            <span
                              className="m-0 text-muted"
                              style={{ fontSize: "12px" }}
                            >
                              (
                              {tx.fType === "creditcard"
                                ? "Card / Paid for others"
                                : tx.fType === "others"
                                  ? "Miscellaneous"
                                  : capitalize(tx.fType)}
                              )
                            </span>
                          </p>

                          <p className="t-sub">
                            From: {capitalize(each.from?.name || "")}
                          </p>

                          <p className="t-amount">₹ {each.amount}</p>
                        </div>
                      </div>

                      {/* RIGHT */}
                      <div className="t-right-details d-flex flex-column">
                        <p style={{ fontSize: "12px" }}>
                          {tx.tDate ? formatToIST(tx.tDate).slice(0, 11) : ""}
                        </p>

                        <p
                          className={`t-status ${
                            each.tStatus === "pending" ? "yello" : "greenn"
                          }`}
                        >
                          {capitalize(each.tStatus)}
                        </p>

                        <Link to={`/transactionDetail/${tx._id}`}>
                          <button className="view-btn">View</button>
                        </Link>
                      </div>
                    </div>

                    {each.reqReceived && (
                      <div className="text-center">
                        <hr />
                        <button
                          className="btn btn-outline-success btn-sm mx-1"
                          disabled={
                            actionLoading?.id === tx._id &&
                            actionLoading?.type === "approve"
                          }
                          onClick={() =>
                            onApprove(each.from?._id, myId, tx._id)
                          }
                        >
                          {actionLoading?.id === tx._id &&
                          actionLoading?.type === "approve" ? (
                            <span className="spinner-border spinner-border-sm"></span>
                          ) : (
                            "Confirm Payment"
                          )}
                        </button>

                        <button
                          className="btn btn-outline-danger btn-sm mx-1"
                          disabled={
                            actionLoading?.id === tx._id &&
                            actionLoading?.type === "reject"
                          }
                          onClick={() => onReject(each.from?._id, myId, tx._id)}
                        >
                          {actionLoading?.id === tx._id &&
                          actionLoading?.type === "reject" ? (
                            <span className="spinner-border spinner-border-sm"></span>
                          ) : (
                            "Reject Request"
                          )}
                        </button>
                      </div>
                    )}
                  </div>
                );
              })
          ) : (
            <p className="empty-text">Nothing to Display</p>
          )}
        </div>
      </div>

      {/* SEND MONEY LIST */}
      <div className={`${cNameOut} flex-column`}>
        <div className="transaction-list">
          {updOweDetails.length > 0 ? (
            updOweDetails
              .filter((each) => each?.transaction)
              .map((each) => {
                const tx = each.transaction;

                return (
                  <div key={each._id} className="transaction-card">
                    <div className="t-details-cont">
                      <div className="t-left-details">
                        <img
                          className="t-img"
                          src="https://cdn-icons-png.flaticon.com/512/5932/5932535.png"
                          alt="transaction"
                        />

                        <div className="t-info">
                          <p className="t-title">
                            {capitalize(tx.tName || "Unnamed")}
                            <br />
                            <span
                              className="m-0 text-muted"
                              style={{ fontSize: "12px" }}
                            >
                              (
                              {tx.fType === "creditcard"
                                ? "Card / Paid for others"
                                : tx.fType === "others"
                                  ? "Miscellaneous"
                                  : capitalize(tx.fType)}
                              )
                            </span>
                          </p>

                          <p className="t-sub">
                            To: {capitalize(each.to?.name || "")}
                          </p>

                          <p className="t-amount">₹ {each.amount}</p>
                        </div>
                      </div>

                      <div className="t-right-details d-flex flex-column">
                        <p style={{ fontSize: "12px" }}>
                          {tx.tDate ? formatToIST(tx.tDate).slice(0, 11) : ""}
                        </p>

                        <p
                          className={`t-status ${
                            each.tStatus === "pending" ? "yello" : "greenn"
                          }`}
                        >
                          {capitalize(each.tStatus)}
                        </p>

                        <Link to={`/transactionDetail/${tx._id}`}>
                          <button className="view-btn">View</button>
                        </Link>
                      </div>
                    </div>

                    <div className="text-center mt-3">
                      {each.tStatus === "pending" &&
                        (each.reqSent ? (
                          <p className="text-muted">Request Sent</p>
                        ) : (
                          <button
                            className="clear-btn"
                            disabled={
                              actionLoading?.id === tx._id &&
                              actionLoading?.type === "confirm"
                            }
                            onClick={() =>
                              onConfirm(myId, each.to?._id, tx._id)
                            }
                          >
                            {actionLoading?.id === tx._id &&
                            actionLoading?.type === "confirm" ? (
                              <span className="spinner-border spinner-border-sm"></span>
                            ) : (
                              "Send Clearance Request"
                            )}
                          </button>
                        ))}
                    </div>
                  </div>
                );
              })
          ) : (
            <p className="empty-text">Nothing to Display</p>
          )}
        </div>
      </div>

      <div
        className="modal fade filters-modal"
        id="exampleModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content filters-content">
            {/* Header */}
            <div className="modal-header filters-header">
              <h5 className="filters-title">Filters</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            {/* Active Filters Preview */}
            <div className="active-filters">
              {filters.type ||
              filters.status ||
              filters.fromDate ||
              filters.toDate ? (
                <>
                  {filters.type && (
                    <span className="filter-chip">
                      {filters.type}
                      <span
                        onClick={() => setfilters({ ...filters, type: "" })}
                      >
                        ×
                      </span>
                    </span>
                  )}

                  {filters.status && (
                    <span className="filter-chip">
                      {filters.status}
                      <span
                        onClick={() => setfilters({ ...filters, status: "" })}
                      >
                        ×
                      </span>
                    </span>
                  )}

                  {filters.fromDate && (
                    <span className="filter-chip">
                      From: {filters.fromDate}
                      <span
                        onClick={() => setfilters({ ...filters, fromDate: "" })}
                      >
                        ×
                      </span>
                    </span>
                  )}

                  {filters.toDate && (
                    <span className="filter-chip">
                      To: {filters.toDate}
                      <span
                        onClick={() => setfilters({ ...filters, toDate: "" })}
                      >
                        ×
                      </span>
                    </span>
                  )}
                </>
              ) : (
                <span className="no-filters-text">No filters applied</span>
              )}
            </div>

            {/* Body */}
            <div className="modal-body filters-body">
              {/* TYPE CHIPS */}
              <div className="filter-group">
                <label className="filter-label">By Type</label>

                <div className="chip-container">
                  {[
                    "restaurant",
                    "creditcard",
                    "others",
                    ...(userDetails.role === "ADMIN"
                      ? ["instamart", "swiggyfood"]
                      : []),
                  ].map((type) => (
                    <div
                      key={type}
                      className={`chip ${
                        filters.type === type ? "chip-active" : ""
                      }`}
                      onClick={() =>
                        setfilters({
                          ...filters,
                          type: filters.type === type ? "" : type,
                        })
                      }
                    >
                      {type}
                    </div>
                  ))}
                </div>
              </div>

              {/* STATUS CHIPS */}
              <div className="filter-group">
                <label className="filter-label">By Status</label>

                <div className="chip-container">
                  {["pending", "cleared"].map((status) => (
                    <div
                      key={status}
                      className={`chip ${
                        filters.status === status ? "chip-active" : ""
                      }`}
                      onClick={() =>
                        setfilters({
                          ...filters,
                          status: filters.status === status ? "" : status,
                        })
                      }
                    >
                      {status}
                    </div>
                  ))}
                </div>
              </div>

              {/* DATE RANGE */}
              <div className="filter-group">
                <label className="filter-label">From</label>
                <div className="date-input-wrapper">
                  <input
                    type="date"
                    className="form-control filter-input"
                    name="fromDate"
                    value={filters.fromDate}
                    onChange={onChange}
                  />
                  {filters.fromDate && (
                    <span
                      className="clear-date"
                      onClick={() => setfilters({ ...filters, fromDate: "" })}
                    >
                      ×
                    </span>
                  )}
                </div>
              </div>

              <div className="filter-group">
                <label className="filter-label">To</label>
                <div className="date-input-wrapper">
                  <input
                    type="date"
                    className="form-control filter-input"
                    name="toDate"
                    value={filters.toDate}
                    onChange={onChange}
                  />
                  {filters.toDate && (
                    <span
                      className="clear-date"
                      onClick={() => setfilters({ ...filters, toDate: "" })}
                    >
                      ×
                    </span>
                  )}
                </div>
              </div>
            </div>

            {/* Sticky Footer */}
            <div className="filters-footer">
              <button className="btn reset-btn" onClick={onReset}>
                Reset All
              </button>

              <button className="btn apply-btn" data-bs-dismiss="modal">
                Done
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OweGet;
